interface DividerProps {
	className?: string;
}

const Divider = ({ className = '' }: DividerProps) => {
	return (
		<div className={`${className}`}>
			<svg
				width="100%"
				height="100%"
				style={{ overflow: 'visible' }}
				preserveAspectRatio="none"
				viewBox="0 0 1112 1"
				fill="currentColor"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path d="M0 1H1112" stroke="currentColor" />
			</svg>
		</div>
	);
};

export default Divider;
